module.exports = "/_next/static/images/phone-43aacfda8407881a83c07c34cad2bded.webp";